import React from 'react';
import { CDN_TYPE_CRM, imageUrlCDN } from 'utils';

const LuckyDayBanner = ({ headBanner }) => {
  const imgSrc = imageUrlCDN(headBanner, CDN_TYPE_CRM);

  return (
    <div className="imageWrapper">
      <img alt="banner" loading="lazy" src={imgSrc} />
    </div>
  );
};

export default LuckyDayBanner;
